import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { ChevronRightIcon } from "../../primitives/Icons/Icons";
import Typography from "../../primitives/Typography/Typography";
import css from "./ActionCard.module.css";

const ActionCard = React.forwardRef(
  (
    { icon: Icon, title, description, onClick, href, className, ...rest },
    ref,
  ) => {
    const Tag = href ? "a" : "button";
    const tagProps = href
      ? { href, target: "_blank", rel: "noopener noreferrer" }
      : { type: "button", onClick };

    return (
      <Tag
        ref={ref}
        className={clsx(css.root, className)}
        {...tagProps}
        {...rest}
      >
        <div className={css.icon}>
          <Icon className={css.iconSvg} />
        </div>
        <div className={css.text}>
          <div className={css.title}>{title}</div>
          {description && (
            <Typography variant="label-lg" color="variant">
              {description}
            </Typography>
          )}
        </div>
        <ChevronRightIcon className={css.arrow} />
      </Tag>
    );
  },
);

ActionCard.displayName = "ActionCard";

ActionCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  className: PropTypes.string,
};

export default ActionCard;
